import React, { Component } from "react";
import logokpru from "../assets/logokpru.png";
import axios from "axios";
import Swal from "sweetalert2";
import ConfigData from "../Components/config";
import "./Home.css";

export default class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Username: "",
      Password: "",
      checknotify: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSsoLogin = this.handleSsoLogin.bind(this);
  }
  componentDidMount() {
    localStorage.clear();
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();
    var pass = this.state.Password.replace("/", "-");
    var pass2 = pass.replace("/", "-");
    var pass3 = pass2.replace("/", "-");
    var pass4 = pass3.replace("/", "-");

    axios
      .get(
        ConfigData.SERVER_URL +
          "FrontEnd_Tabian/Login/LoginRubrong/" +
          this.state.Username +
          "/" +
          pass4
      )
      .then((res) => {
        if (res.data.data.length !== 0) {
          if (res.data.data[0]["checkstatus"] === "student") {
            if (this.state.Username.substring(0, 2) >= 60) {
              axios
                .get(
                  "https://mua.kpru.ac.th/FrontEnd_Tabian/addnotify/checkregisternotify/" +
                    this.state.Username +
                    "/students"
                )
                .then((students) => {
                  if (students.data.token !== "") {
                    localStorage.setItem("token", res.data.token);
                    localStorage.setItem("id", this.state.Username);
                    localStorage.setItem("checkstatus", "student");
                    localStorage.setItem("name", res.data.data[0].PNAME + res.data.data[0].NAME);
                    axios
                      .get(
                        "https://mua.kpru.ac.th/FrontEnd_Tabian/petition/ShowReportPetition/" +
                          this.state.Username
                      )
                      .then((ShowReportPetition) => {
                        if (ShowReportPetition.data.length !== 0) {
                          axios
                            .get(
                              "https://arit.kpru.ac.th/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
                                this.state.Username +
                                "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
                            )
                            .then((checkconfirm) => {
                              if (checkconfirm.data.length !== 0) {
                                window.location.href = "/rubrongkpru/Datarubrong";
                              } else {
                                window.location.href =
                                  "https://arit.kpru.ac.th/ap/account/?nu=pdpaAgree&code=" +
                                  btoa(this.state.Username) +
                                  "&status=" +
                                  btoa("3") +
                                  "&url=" +
                                  btoa("https://e-student.kpru.ac.th/rubrongkpru/Datarubrong");
                              }
                            });
                        } else {
                          axios
                            .get(
                              "https://arit.kpru.ac.th/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
                                this.state.Username +
                                "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
                            )
                            .then((checkconfirm) => {
                              if (checkconfirm.data.length !== 0) {
                                window.location.href = "/rubrongkpru/Addpetition";
                              } else {
                                window.location.href =
                                  "https://arit.kpru.ac.th/ap/account/?nu=pdpaAgree&code=" +
                                  btoa(this.state.Username) +
                                  "&status=" +
                                  btoa("3") +
                                  "&url=" +
                                  btoa("https://e-student.kpru.ac.th/rubrongkpru/Addpetition");
                              }
                            });
                        }
                      });
                  } else {
                    this.setState({ checknotify: true });
                  }
                });
            } else {
              localStorage.setItem("token", res.data.token);
              localStorage.setItem("id", this.state.Username);
              localStorage.setItem("checkstatus", "student");
              localStorage.setItem("name", res.data.data[0].PNAME + res.data.data[0].NAME);
              window.location.href = "/rubrongkpru/Datarubrong";
            }
          } else if (res.data.data[0]["checkstatus"] === "teacher") {
            localStorage.setItem("token", res.data.token);
            localStorage.setItem("id", this.state.Username);
            localStorage.setItem("checkstatus", "teacher");
            localStorage.setItem("name", res.data.data[0].prenm + res.data.data[0].poname);
            localStorage.setItem("shortname", res.data.data[0]["name"]);
            if (res.data.data[0]["name"] === "ฆัมภิชา") {
              window.location.href = "/rubrongkpru/ShowcertificateVicerector";
            } else if (res.data.data[0]["name"] === "จิรพงค์") {
              // || res.data.data[0]['name'] === "วันวิสา"
              window.location.href = "/rubrongkpru/ShowcertificateHeadtabian";
            }
            //  else if (res.data.data[0]['name'] === "จิรพงค์" || res.data.data[0]['name'] === "วันวิสา") {
            //     window.location.href = '/rubrongkpru/ShowcertificateHeadtabian';
            // }
            else {
              window.location.href = "/rubrongkpru/ShowcertificateTeacher";
            }
          } else if (res.data.data[0]["checkstatus"] === "tabian") {
            localStorage.setItem("token", res.data.token);
            localStorage.setItem("id", res.data.data[0]["citizent"]);
            localStorage.setItem("checkstatus", "tabian");
            localStorage.setItem(
              "name",
              res.data.data[0].prename_admin +
                res.data.data[0].name_admin +
                "  " +
                res.data.data[0].lname_admin
            );
            localStorage.setItem("shortname", res.data.data[0].name_admin);
            if (res.data.data[0].name_admin === "ผดุงพร") {
              window.location.href = "/rubrongkpru/ShowcertificateHeadtabian";
            } else {
              window.location.href = "/rubrongkpru/Showcertificate";
            }
          }
        } else {
          Swal.fire("เข้าสู่ระบบไม่สำเร็จ", "รหัสผู้ใช้งานและรหัสผ่านไม่ถูกต้อง", "error");
        }
      });
  }

  handleSsoLogin() {
    const returnUrl = `${window.location.origin}/rubrongkpru/sso`;
    window.location.href =
      ConfigData.SERVER_URL +
      "FrontEnd_Tabian/Login/SsoStart?return_url=" +
      encodeURIComponent(returnUrl);
  }

  render() {
    return (
      <div className="login-page">
        <div className="login-card">
          <div className="login-card-main">
            <img className="login-logo" src={logokpru} alt="KPRU" />
            <h1 className="login-brand">ระบบขอเอกสารทางการศึกษา</h1>
            <div className="login-subtitles">
              <p>สำนักส่งเสริมวิชาการและงานทะเบียน</p>
              <p>มหาวิทยาลัยราชภัฏกำแพงเพชร</p>
            </div>

            <form id="login-postpone" className="login-form" onSubmit={this.handleSubmit}>
              <div className="login-field">
                <label htmlFor="Username">Username</label>
                <input
                  id="Username"
                  type="text"
                  name="Username"
                  autoComplete="username"
                  value={this.state.Username}
                  onChange={this.handleChange}
                  required
                />
              </div>
              <div className="login-field">
                <label htmlFor="Password">Password</label>
                <input
                  id="Password"
                  type="password"
                  name="Password"
                  autoComplete="current-password"
                  value={this.state.Password}
                  onChange={this.handleChange}
                  required
                />
              </div>

              {this.state.checknotify ? (
                <div className="login-alert">
                  <div className="login-alert-title">แจ้งเตือน !</div>
                  ไม่สามารถเข้าใช้งานระบบได้ เนื่องจากท่านยังไม่ลงทะเบียน KPRU Notify
                  <button type="button" className="login-alert-btn">
                    คลิกเพื่อลงทะเบียน KPRU Notify
                  </button>
                </div>
              ) : null}

              <button type="submit" className="login-submit">
                <i className="fas fa-sign-in-alt" aria-hidden="true" />
                เข้าสู่ระบบ
              </button>
            </form>

            <div className="login-sso-divider">
              <span>หรือ</span>
            </div>
            <button type="button" className="login-sso-btn" onClick={this.handleSsoLogin}>
              เข้าสู่ระบบด้วย SSO KPRU
            </button>
          </div>

          <div className="login-note">
            <div className="login-note-title">หมายเหตุการเข้าสู่ระบบ</div>
            <div className="login-note-block">
              <div className="login-note-role">นักศึกษา</div>
              <ul>
                <li>
                  <strong>Username</strong> รหัสนักศึกษา เช่น 6213209xx
                </li>
                <li>
                  <strong>Password</strong> วันเดือนปีเกิด วว/ดด/ปป เช่น 13/12/60
                </li>
              </ul>
            </div>
            <div className="login-note-block">
              <div className="login-note-role">อาจารย์ / เจ้าหน้าที่</div>
              <ul>
                <li>
                  <strong>Username</strong> รหัสประจำตัวประชาชน
                </li>
                <li>
                  <strong>Password</strong> วันเดือนปีเกิด หรือรหัสผ่านที่ใช้ในระบบงานทะเบียน
                </li>
              </ul>
            </div>
            <a
              href="https://mua.kpru.ac.th/apipostpone/PostponePDF/guide_student_rubrong.pdf"
              target="_blank"
              rel="noreferrer"
            >
              คู่มือการใช้งาน →
            </a>
          </div>
        </div>
      </div>
    );
  }
}
